var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 69,
    viewBox: "0 0 81 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9491 41.5208C50.5454 41.5208 59.136 32.9304 59.136 22.2965C59.136 11.6625 50.5075 3.07202 39.9491 3.07202C29.3528 3.07202 20.7622 11.6625 20.7622 22.2965C20.7622 32.9304 29.3528 41.5208 39.9491 41.5208Z",
    fill: "url(#paint0_linear_1438_77024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1583 3.63924C60.7434 3.63924 61.2179 3.16239 61.2179 2.57961C61.2179 1.99303 60.7434 1.52002 60.1583 1.52002C59.5733 1.52002 59.0987 1.99303 59.0987 2.57961C59.0987 3.16239 59.5733 3.63924 60.1583 3.63924Z",
    fill: "#253040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7851 9.65608C22.3702 9.65608 22.8447 9.17924 22.8447 8.59645C22.8447 8.00988 22.3702 7.53687 21.7851 7.53687C21.2 7.53687 20.7255 8.00988 20.7255 8.59645C20.7255 9.17924 21.2 9.65608 21.7851 9.65608Z",
    fill: "#253040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3136 30.0917C16.4005 30.0917 17.2815 29.2099 17.2815 28.1238C17.2815 27.0377 16.4005 26.156 15.3136 26.156C14.2267 26.156 13.3457 27.0377 13.3457 28.1238C13.3457 29.2099 14.2267 30.0917 15.3136 30.0917Z",
    fill: "#253040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1438_77024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2306 12.1959V34.4629C58.2306 35.1176 57.6864 35.6625 57.0329 35.6625H23.1978C22.5446 35.689 22 35.1441 22 34.4894V12.1959C22 11.5185 22.5446 11 23.1978 11H57.0329C57.7133 11 58.2306 11.545 58.2306 12.1959Z",
    fill: "#4A5463"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2319 12.1956V13.9137H22.0013V12.1956C22.0013 11.5182 22.5458 10.9998 23.199 10.9998H57.0341C57.7146 10.9998 58.2319 11.5447 58.2319 12.1956Z",
    fill: "#384252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1229 22.5422C35.6792 22.5422 36.13 22.0919 36.13 21.5356C36.13 20.9793 35.6792 20.5251 35.1229 20.5251C34.5666 20.5251 34.1155 20.9793 34.1155 21.5356C34.1155 22.0919 34.5666 22.5422 35.1229 22.5422Z",
    fill: "#E3E8EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1398 22.5422C45.6961 22.5422 46.1472 22.0919 46.1472 21.5356C46.1472 20.9793 45.6961 20.5251 45.1398 20.5251C44.5839 20.5251 44.1328 20.9793 44.1328 21.5356C44.1328 22.0919 44.5839 22.5422 45.1398 22.5422Z",
    fill: "#E3E8EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7643 29.1567H38.607C38.1169 29.1567 37.7086 28.748 37.7086 28.256C37.7086 27.7678 38.1169 27.3591 38.607 27.3591H41.737C42.2271 27.3591 42.6355 27.7678 42.6355 28.256C42.6627 28.748 42.2544 29.1567 41.7643 29.1567Z",
    fill: "#E3E8EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6081 12.9598C23.8336 12.9598 24.0164 12.7781 24.0164 12.5511C24.0164 12.324 23.8336 12.1423 23.6081 12.1423C23.3825 12.1423 23.1998 12.324 23.1998 12.5511C23.1998 12.7781 23.3825 12.9598 23.6081 12.9598Z",
    fill: "#F9FAFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8878 12.9598C25.1133 12.9598 25.2961 12.7781 25.2961 12.5511C25.2961 12.324 25.1133 12.1423 24.8878 12.1423C24.6622 12.1423 24.4794 12.324 24.4794 12.5511C24.4794 12.7781 24.6622 12.9598 24.8878 12.9598Z",
    fill: "#F9FAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.194 12.9598C26.4196 12.9598 26.6024 12.7781 26.6024 12.5511C26.6024 12.324 26.4196 12.1423 26.194 12.1423C25.9685 12.1423 25.7857 12.324 25.7857 12.5511C25.7857 12.7781 25.9685 12.9598 26.194 12.9598Z",
    fill: "#F9FAFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7629 8.11608C56.4908 8.11608 56.2728 7.89662 56.2728 7.62414V2.15197C56.2728 1.87949 56.4908 1.66382 56.7629 1.66382C57.035 1.66382 57.253 1.87949 57.253 2.15197V7.62414C57.253 7.89662 57.035 8.11608 56.7629 8.11608Z",
    fill: "#E3E8EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.737 12.3056C60.737 12.0331 60.9546 11.8174 61.2267 11.8174H66.6982C66.9703 11.8174 67.1883 12.0331 67.1883 12.3056C67.1883 12.578 66.9703 12.7975 66.6982 12.7975H61.2267C60.9546 12.7975 60.737 12.578 60.737 12.3056Z",
    fill: "#E3E8EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3011 8.76679C60.1104 8.57758 60.1104 8.25213 60.3011 8.05912L64.1938 4.19529C64.3841 4.00229 64.7107 4.00229 64.9014 4.19529C65.0918 4.3845 65.0918 4.70996 64.9014 4.90296L61.0361 8.76679C60.8181 8.95979 60.4915 8.95979 60.3011 8.76679Z",
    fill: "#E3E8EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1438_77024",
    x: 0,
    y: 0,
    width: 80.2307,
    height: 68.6633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1438_77024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1438_77024",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1438_77024",
    x1: 40.3891,
    y1: -3.89917,
    x2: 39.9972,
    y2: 16.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData2);
export default __webpack_public_path__ + "static/media/no-data-2.8a42f82a0489278175ba605aedcdd7a9.svg";
export { ForwardRef as ReactComponent };